import styled, { css } from "styled-components";
import { borderRadius, fontSizes, rawColors, spacing } from "@magicbi/ui-library";
import type { StatusMarkerState } from "./StatusMarker.types";

const STATE: Record<StatusMarkerState, ReturnType<typeof css>> = {
  done: css`
    background: ${rawColors.accent.green500};
    color: ${rawColors.text.white};
  `,
  warn: css`
    background: ${rawColors.accent.amber500};
    color: ${({ theme }) => theme.colors.text.primary};
  `,
  bad: css`
    background: ${rawColors.accent.red500};
    color: ${rawColors.text.white};
  `,
  current: css`
    background: ${({ theme }) => theme.colors.interactive.primary};
    color: ${rawColors.text.white};
  `,
  todo: css`
    background: ${({ theme }) => theme.colors.surface.primary};
    color: ${({ theme }) => theme.colors.text.tertiary};
    border: 0.09375rem solid ${({ theme }) => theme.colors.border.stroke}; /* GAP: 1.5px ring (borderWidth has 0.8, 1, 2) */
  `,
};

/** The step-state circle (design `.ico`): 18px, 10px bold glyph. */
export const Marker = styled.span<{ $state: StatusMarkerState }>`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: ${spacing[4.5]};
  height: ${spacing[4.5]};
  border-radius: ${borderRadius.full};
  font-size: ${fontSizes["overline-4"]};
  font-weight: 700;
  line-height: 1;
  ${({ $state }) => STATE[$state]}

  svg {
    width: 0.625rem;
    height: 0.625rem;
  }
`;
